import type { DemandeProformaDTO } from '@/features/api/extranet/dto/Demande/PROFORMA'
import type { NaturesFichiersDemandeCallback } from '@/features/domaine/regles-akto/shared/NaturesFichiersDemandeCallback.ts'

export const Facture = 'Facture' as const
export const ProformaGroupee = 'ProformaGroupee' as const

export const getNaturesFichiersProforma: NaturesFichiersDemandeCallback<DemandeProformaDTO> = (_, __) => {
  const obligatoires: string[] = [Facture, ProformaGroupee]
  const facultatifs = ['Autre']
  const facultatifsDefaut: string[] = []

  return {
    obligatoires: obligatoires,
    facultatifs: facultatifs,
    facultatifsDefaut: facultatifsDefaut,
    nombreFichiersMaximum: {},
    nombreFichiersMinimum: {},
  }
}
